import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { TrendencyFullscreenLoaderService } from '../../loading';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private readonly fullscreenLoader: TrendencyFullscreenLoaderService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.fullscreenLoader.show();
    return next.handle(req).pipe(finalize(() => this.fullscreenLoader.hide()));
  }
}
